import { Flex, Spin } from "@/atoms"

import styles from "./Fallback.module.scss"

export const Fallback = () => {
  return (
    <Flex className={styles.tableFallback} justify="center" align="center">
      <Spin />
    </Flex>
  )
}
